<div class="sd-form">
  <div class="sd-form__head">
    <div class="sd-form__head-text">
      <h3 class="sd-form__title">Request approval</h3>
      <p class="sd-form__subtitle">{{ options?.recordTitle || 'They’ll find it on their Tasks card.' }}</p>
    </div>
    <button type="button" class="sd-icon-btn" aria-label="Close" (click)="cancel()">
      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <form class="sd-form__body" (ngSubmit)="submit()" novalidate>
    <!-- What needs approving: the whole record, or just some of its fields. -->
    <div class="sd-field" *ngIf="approvableFields.length > 0">
      <span class="sd-field__label" id="rtm-scope-label">What needs approving?</span>
      <div class="sd-choices" role="radiogroup" aria-labelledby="rtm-scope-label">
        <label class="sd-choice" [class.is-selected]="scope === 'whole'">
          <input class="sd-choice__input" type="radio" name="rtm-scope" value="whole" [(ngModel)]="scope">
          <span class="sd-choice__radio" aria-hidden="true"></span>
          <span class="sd-choice__text">
            <span class="sd-choice__title">The whole {{ recordTypeName }}</span>
            <span class="sd-choice__desc">They approve it as it stands.</span>
          </span>
        </label>
        <label class="sd-choice" [class.is-selected]="scope === 'fields'">
          <input class="sd-choice__input" type="radio" name="rtm-scope" value="fields" [(ngModel)]="scope">
          <span class="sd-choice__radio" aria-hidden="true"></span>
          <span class="sd-choice__text">
            <span class="sd-choice__title">Just some fields</span>
            <span class="sd-choice__desc">Only these are highlighted for them, e.g. the account coding.</span>
            <span class="rtm-fields" *ngIf="scope === 'fields'">
              <span class="rtm-fields__group" *ngIf="headerFields.length">
                <span class="rtm-fields__heading">{{ recordTypeName | titlecase }}</span>
                <label class="rtm-field" *ngFor="let f of headerFields">
                  <input class="sd-checkbox" type="checkbox" [checked]="chosen.has(f.key)" (change)="toggle(f.key)">
                  <span>{{ f.label }}</span>
                </label>
              </span>
              <span class="rtm-fields__group" *ngIf="lineFields.length">
                <span class="rtm-fields__heading">Each line</span>
                <label class="rtm-field" *ngFor="let f of lineFields">
                  <input class="sd-checkbox" type="checkbox" [checked]="chosen.has(f.key)" (change)="toggle(f.key)">
                  <span>{{ f.label }}</span>
                </label>
              </span>
            </span>
          </span>
        </label>
      </div>
      <span class="sd-field__error" *ngIf="submitted && noFieldsChosen">Choose at least one field</span>
    </div>

    <div class="sd-field">
      <label class="sd-field__label" for="rtm-assignee">Who should approve it?</label>
      <app-person-picker labelForId="rtm-assignee" [organizationId]="options?.organizationId"
                         [(value)]="assignee" [includeRoles]="true"
                         [invalid]="submitted && !assignee"></app-person-picker>
      <span class="sd-field__error" *ngIf="submitted && !assignee">Choose who to ask</span>
    </div>

    <div class="sd-form__row rtm-row">
      <div class="sd-field">
        <label class="sd-field__label" for="rtm-due">Due <span class="sd-field__optional">Optional</span></label>
        <input id="rtm-due" name="dueDate" class="sd-input" type="date" [min]="today" [(ngModel)]="dueDate"
               [class.is-placeholder]="!dueDate" [class.is-invalid]="submitted && dueInPast">
        <span class="sd-field__error" *ngIf="submitted && dueInPast">Pick today or later</span>
      </div>
      <label class="rtm-priority">
        <input class="sd-checkbox" type="checkbox" name="highPriority" [(ngModel)]="highPriority">
        <span>High priority</span>
      </label>
    </div>

    <div class="sd-field">
      <label class="sd-field__label" for="rtm-note">Note <span class="sd-field__optional">Optional</span></label>
      <textarea id="rtm-note" name="description" class="sd-input rtm-note" rows="3"
                placeholder="Anything they should know" [(ngModel)]="description"></textarea>
    </div>

    <div class="sd-form__error" *ngIf="errorMessage" role="alert">
      {{ errorMessage }}
      <ul class="rtm-error-list" *ngIf="errorDetails.length"><li *ngFor="let d of errorDetails">{{ d }}</li></ul>
    </div>

    <!-- Lets Enter submit from any field. -->
    <button type="submit" hidden></button>
  </form>

  <div class="sd-form__footer">
    <button type="button" class="sd-btn sd-btn--secondary" [disabled]="saving" (click)="cancel()">Cancel</button>
    <button type="button" class="sd-btn sd-btn--primary" [disabled]="saving || loadingFields" (click)="submit()">
      {{ saving ? 'Sending…' : 'Send request' }}
    </button>
  </div>
</div>
